
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
    import { DataTableHeader } from 'vuetify';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import paginacion from './lista-listado-paginacion.vue';
    import { Pregunta } from '@/__env/lib/MercadoLibre/Preguntas';
    import { UsuarioActual } from '@/views/a-login/login-controlador';
    import JQuery from 'jquery';
    import moment from 'moment';
    import { Wait } from '@/__env/ext';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            paginacion
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;
        public get Usuario()
        {
            return UsuarioActual;
        }

        @Prop()
        public Item: Pregunta;

        @Prop( { default: false } )
        public Ocultar: boolean;
        @Watch( 'Ocultar' ) onOcultar()
        {
            this.Oculto = this.Ocultar;
        }
        public Oculto: boolean = true;

        public SaludoInicial: boolean = true;
        public SaludoFinal: boolean = true;
        public Respuesta: string = '';


        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        mounted()
        {
            let it = document.getElementById( this.Item.Id + '-pregunta-contenido' );
            it.addEventListener( 'mouseenter', this.MouseEnter );
            it.addEventListener( 'mouseleave', this.MouseLeave );

            this.Eventos.push( this.Controlador.onEnviarARespuesta.subscribe( x => this.AgregarARespuesta( x ) ) );
            this.Eventos.push( this.Controlador.onSiguentePregunta.subscribe( ( x, even ) =>
            {
                if ( x && x.Id == this.Item.Id && !this.Seleccionada )
                {
                    even.stopPropagation();
                    this.Seleccionar();
                } else
                {
                    this.Seleccionada = false;
                }
            } ) );

            this.Eventos.push( this.Controlador.onActualizarPregunta.subscribe( ( x, even ) =>
            {
                if ( x.Id == this.Item.Id)
                {
                    this.Item.Recargar( x.Json );
                    this.Refrescar();
                    if ( this.Seleccionada || !this.Oculto )
                    {
                        this.Controlador.SiguientePregunta();
                    }
                }
            } ) );
        }


        public Focused: boolean = false;
        public Mouse: boolean = false;
        MouseEnter()
        {
            this.Mouse = true;
        }

        MouseLeave()
        {
            this.Mouse = false;
        }


        AgregarARespuesta( x: string )
        {
            if ( this.Oculto )
                return;

            let intp = document.getElementById( this.Item.Id + '-pregunta-input' ) as HTMLTextAreaElement;
            if ( intp.selectionStart > 0 )
            {
                this.Respuesta = this.Respuesta.insertar( intp.selectionStart, ` ${x} ` );
            } else
            {
                this.Respuesta += ' ' + x;
            }
        }

        AbrirPublicacion()
        {
            if ( this.Item.Publicacion )
            {
                window.open( this.Item.Publicacion.Link );
            }
        }

        Detalles()
        {
            this.Controlador.Vista.Modo = 'detalles';
            this.Controlador.Vista.SubModo = 'publicacion';
        }

        CalcularEnvio()
        {
            this.Controlador.Vista.Modo = 'envios';
        }

        AgregarLink()
        {
            this.Controlador.Vista.Modo = 'publicaciones';
        }

        RespuestasRapidas()
        {
            this.Controlador.Vista.Modo = 'respuestas';
        }

        Seleccionar()
        {
            if ( this.Oculto )
            {
                this.Controlador.Vista.Modo = 'respuestas';
                this.Controlador.Seleccionada = this.Item;
                this.Seleccionada = true;
                this.$emit( 'seleccionado', this.Item );
                this.Oculto = false;
                this.$nextTick( () =>
                {
                    document.getElementById( this.Item.Id + '-pregunta-input' ).focus();
                } );
            }
        }

        public EliminarDeInterfaz: boolean = false;
        public Seleccionada: boolean = false;
        public Enviando: boolean = false;
        public Enviada: boolean = false;
        async Enviar()
        {
            this.Enviando = true;
            this.Respuesta = this.Item.Formatear( this.Respuesta, this.SaludoInicial, this.SaludoFinal );
            let e = await this.Item.Responder( this.Respuesta );
            if ( e == 'ya-respondida' )
            {
                Utiles.Notificaciones.Completado( 'Pregunta respondida por otro usuario!' );
            }
            else if ( e == 'ok' )
            {
                Utiles.Notificaciones.Completado( 'Pregunta respondida!' );
            } else
            {
                Utiles.Notificaciones.Error( 'Error al responder' )
                return;
            }

            this.Enviando = false;
            this.Enviada = true;
            await Wait( 1000 );
            this.Controlador.SiguientePregunta();
            await Wait( 50 )
            this.EliminarDeInterfaz = true;

        }

       public get Ok()
        {
            return this.Respuesta.trim().length > 0;
        }

        Bloquear()
        {
            this.Respuesta = this.Item.Formatear( this.Respuesta, this.SaludoInicial, this.SaludoFinal );

        }


        KeyUp( e: KeyboardEvent )
        {
            if ( e.key.toLowerCase() == 'enter' && e.altKey )
            {
                if ( this.Ok )
                    this.Enviar();
            }
            else if ( e.key.toLowerCase() == '1' && e.ctrlKey)
            {
                this.AgregarLink();
            }
            else if ( e.key.toLowerCase() == '2' && e.ctrlKey)
            {
                this.CalcularEnvio();
            }
            else if ( e.key.toLowerCase() == '3' && e.ctrlKey )
            {
                this.RespuestasRapidas();
            }


        }

        public Refresh: boolean = true;
        public Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => { this.Refresh = true; } );
        }

    }
